import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { colors } from '../../styles/vars/colors.style'

export const ImageLabel = styled.div`
  align-items: center;
  color: ${colors.light};
  position: absolute;
  display: flex;
  right: 0;

  ${clamp('bottom', 15, 32)}
  ${clamp('left', 15, 32)}
  
  svg {
    display: inline-block;
    margin-right: 1.1rem;

    circle {
      stroke: ${colors.light};
    }
    path {
      fill: ${colors.light};
    }
  }
`
